import { defineStore } from "pinia";

export const useEvaluationGravityStore = defineStore('evaluationGravity', {
    state: () => ({
        evaluationGravity: {},
        evaluationGravities: [],
    }),
    actions: {
        setEvaluationGravity(evaluationGravity) {
            this.evaluationGravity = evaluationGravity
        },
        setEvaluationGravities(evaluationGravities) {
            this.evaluationGravities = evaluationGravities
        },
        addEvaluationGravity(evaluationGravity) {
            this.evaluationGravities.unshift(evaluationGravity)
        },
        updateEvaluationGravity(evaluationGravity) {
            let index = this.evaluationGravities.findIndex(cl => cl.id === evaluationGravity.id)
            this.evaluationGravities.splice(index, 1, evaluationGravity)
        },
        deleteEvaluationGravity(evaluationGravity) {
            let index = this.evaluationGravities.findIndex(cl => cl.id === evaluationGravity.id)
            this.evaluationGravities.splice(index, 1)
        },
    },
});